import {Cursor} from "./cursor";
import {MarshalParameters} from "./marshal";
import {RegisterValue} from "./register";

export interface ParameterDescription {
    description: string
    type: (string | string[])
    defaultValue?: RegisterValue
}
export interface ActionDescription {
    description: string
    parameters: {[key: string]: ParameterDescription}
}
export abstract class Action {
    protected constructor(public details: ActionDescription = {
        description: "The definition of the action is missing a description",
        parameters: {}
    }) {}
    public terminating = () => false;

    public abstract Resolve(cursor: Cursor, parameters: MarshalParameters): boolean;
}
